import {Divider} from 'antd'

import styles from './BorrowerDetails.module.scss'
import {logout} from 'modules/auth'
import {useOpen} from 'common/hooks'
import {Modal, Text, Button, UserAvatar} from 'common/components'
import {TERMS_URL, PRIVACY_URL, FAQ_URL} from 'common/constants'
import {
  ProfileForm,
  BorrowerPasswordChangeForm,
  AccountDeleteForm,
  useGetProfile,
} from '..'

interface MenuButtonProps {
  title: string
  href?: string
  onClick?: () => void
}

export default function BorrowerDetails() {
  const {data: profile} = useGetProfile()

  const handleLogout = () => logout()

  return (
    <div>
      <div className={styles.header}>
        <UserAvatar size={120} src={profile.photo} alt={profile.firstName} />
        <EditProfile />
      </div>
      <Text as="h2" weight="medium" mb={6}>
        {profile.firstName} {profile.lastName}
      </Text>
      <Text color="grey" size="xs" mb={2}>
        {profile.email}
      </Text>
      <Text color="grey" size="xs" mb={40}>
        {profile.phone}
      </Text>
      <ul className={styles.list}>
        <MenuButton title="FAQ" href={FAQ_URL} />
        <MenuButton title="Terms & Conditions" href={TERMS_URL} />
        <MenuButton title="Privacy Policy" href={PRIVACY_URL} />
      </ul>
      <Divider />
      <ul className={styles.list}>
        <ChangePassword />
        <DeleteAccount />
        <MenuButton title="Log out" onClick={handleLogout} />
      </ul>
    </div>
  )
}

const EditProfile = () => {
  const [isOpen, handleOpen, handleClose] = useOpen()

  return (
    <>
      <Button variant="secondary" onClick={handleOpen}>
        edit profile
      </Button>
      <Modal title="Edit profile" open={isOpen} onCancel={handleClose}>
        <ProfileForm onClose={handleClose} />
      </Modal>
    </>
  )
}

const ChangePassword = () => {
  const [isOpen, handleOpen, handleClose] = useOpen()

  return (
    <>
      <MenuButton title="Change password" onClick={handleOpen} />
      <Modal title="Change password" open={isOpen} onCancel={handleClose}>
        <BorrowerPasswordChangeForm onClose={handleClose} />
      </Modal>
    </>
  )
}

const DeleteAccount = () => {
  const [isOpen, handleOpen, handleClose] = useOpen()

  return (
    <>
      <MenuButton title="Delete account" onClick={handleOpen} />
      <Modal
        width={486}
        title="Are you sure?"
        open={isOpen}
        onCancel={handleClose}
      >
        <AccountDeleteForm />
      </Modal>
    </>
  )
}

const MenuButton = ({title, href, onClick}: MenuButtonProps) => {
  const Tag = href ? 'a' : 'button'

  const props = href ? linkProps : undefined

  return (
    <li>
      <Tag {...props} className={styles.button} href={href} onClick={onClick}>
        {title}
      </Tag>
    </li>
  )
}

const linkProps = {
  target: '_blank',
  rel: 'noreferrer noopener',
}
